
import {AppStateService} from "../../services/appStateService";
import { AccessoryService } from "../accessoryComponent/accessoryService";
import {UIService} from "../UIService";

export class AddToCartModalService
{
    private appStateService: AppStateService;
    private uiService: UIService;
    private accessoryService: AccessoryService;

    constructor()
    {
        this.appStateService = new AppStateService();
        this.uiService = new UIService();
        this.accessoryService = new AccessoryService();
    }

    public refreshComponentTemplate()
    {
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'isInEditMode', this.isInEditMode());
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'notInEditMode', !this.isInEditMode());
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'isSalesman', false);
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'showIncludedOptionsInCartModal', false);
        // this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'showIncludedOptionsInCartModal', this.accessoryService.hasIncludedAccessories());
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'showAdditionalOptionsTitle', false);
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'showAdditionalOptionsInCartModal', this.accessoryService.hasAdditionalAccessories());
        this.appStateService.setAppSettingTemplateFlag('addToCartModal', 'showAccessoriesInCartModal', this.showAccessoriesInCartModal());
        this.uiService.refreshElementsInModule('addToCartModal');
    }

    public showAccessoriesInCartModal()
    {
        return this.accessoryService.hasAdditionalAccessories();
    }

    public isInEditMode()
    {
        return this.uiService.isInEditMode();
    }

    public isSalesman()
    {
        const isSalesman = this.appStateService.getAppSettingOption('isSalesman');

        if (isSalesman) {
            return true;
        }
        return false;
    }
}
